module.exports = __webpack_public_path__ + "img/txt_info1.4a267580.png";